
<template>
  <div>
    <b-modal v-model="lineModal"  size="sm" scrollable>
      <template v-slot:modal-header> 
        <div class="w-90 pr-0">
          <p class="text-center mt-3 mb-0 pl-5"><b>{{$t("message.selectCountry")}}</b></p>  
          
        </div>
        <div class="w-10 px-0">
          <button class="btn btn-md " @click="closeModal()"><h3>×</h3></button>          
        </div>      
      </template>
        <div class="row">
          <div class="col-12 pl-4">
            <b-form-group >
              <b-form-radio class="mb-3" v-model="selected"  v-for="line in line_ids" :value="line.link" :key="line.id">{{line.label}}</b-form-radio>
            </b-form-group>
          </div>
        </div>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button  class="line-inquiry py-2 px-4 width100" @click="inquiry" > {{$t("message.goInquiry")}} </b-button>
        </div>
      </template>
      
    </b-modal>
  </div>
</template>
<script>
export default {
  components: {
  },
  props:{
    lineModal: false
  },
  data() {
    return {
      selected: "",
      line_ids: [
        {id: "VI", label: "ベトナム", link: "https://lin.ee/2KRJahn"},
        {id: "CH", label: "中国", link: "https://lin.ee/dcT7uX4"},
        {id: "LA", label: "ラオス", link: "https://lin.ee/LqfKEnY"},
        {id: "MY", label: "マレーシア", link: "https://lin.ee/ybqfo3I"},
        {id: "BD", label: "バングラデシュ", link: "https://lin.ee/pGaRZHz"},
        {id: "IN", label: "インド", link: "https://lin.ee/zq4M4UR"},
        {id: "MN", label: "モンゴル", link: "https://lin.ee/oSpFAjM"},
        {id: "NP", label: "ネパール", link: "https://lin.ee/YLjIJH9"},
        {id: "ID", label: "インドネシア", link: "https://lin.ee/a2ywfYk"},
        {id: "TH", label: "タイ", link: "https://lin.ee/EtWt3gN"},
        {id: "PH", label: "フィリピン", link: "https://lin.ee/qL0vjrW"},
        {id: "MM", label: "ミャンマー", link: "https://lin.ee/JjiqHmN"},
        {id: "UZ", label: "ウズベキスタン", link: "https://lin.ee/j6uCkOO"},
        {id: "PK", label: "パキスタン", link: "https://lin.ee/iIPuFcW"},
      ]
    }

  },
  methods: {
    closeModal(){
      this.lineModal = false
    },
    showModal(){
      this.lineModal = true
    },
    inquiry(){
      window.open(this.selected);
    },
  },
  watch: {
    lineModal(v){
      if(v == false) {
         this.$emit("hideLine")
      }
    }
  }
}
</script>
<style scoped lang="scss"> 
.btn{
  padding: .235rem .75rem;
}
@media (max-width: 768px) {
  .navbar-nav {
    -webkit-box-orient: horizontal !important;
    display: -webkit-box;
  }
}

.modal-header{
  border-bottom: 0px solid #dee2e6;
  text-size: 16px;
  text-align: center!important;
}

.facebook{
  background: #1877F2 !important;
  color: #FFFFFF;
  font-size: 14px;
  width: 90%
}

.sign_up{
  background: #FFFFFF !important;
  color: #F29147 !important;
  border-color: #FFFFFF !important;
  font-size: 14px;

  &:hover {
    box-shadow: none !important;
  }
}

.line{
  position: relative;
  top: -25px;
  z-index: 100;
}
.line-button{
  padding-top: 12px;
  padding-bottom: 12px;
  font-size: 16px;
  background-color: #FFFFFF;
  color: #000000;
}

.line-title{
  border-bottom: 1px solid rgba(1, 1, 20, 0.12);
}

.line-inquiry{
  background-color: #00B900;
}
</style>
